import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useProfileResource } from '../resources'

export type Profile = {
  id: string
  email: string
  name: string
  language: string | null
  isAdmin: boolean
}

export const useProfileStore = defineStore('profile', () => {
  const { getProfile } = useProfileResource()
  const profile = ref<Profile | null>(null)
  const loaded = ref(false)

  const load = async () => {
    if (loaded.value) return
    const { data } = await getProfile()
    profile.value = data ?? null
    loaded.value = true
  }

  return { profile, loaded, load }
})
